import React, { useEffect } from 'react';
import useComponentHighLight from '../hooks/useComponentHighlight';
var ComponentHighlightWrapper = function (props) {
    var _a = useComponentHighLight(), highlightElement = _a.highlightElement, removeHighlightElement = _a.removeHighlightElement;
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.shouldHighlightElement) {
            highlightElement(props === null || props === void 0 ? void 0 : props.elementIdToHighlight);
        }
        else {
            removeHighlightElement(props === null || props === void 0 ? void 0 : props.elementIdToHighlight);
        }
    }, [props === null || props === void 0 ? void 0 : props.shouldHighlightElement]);
    if (!(props === null || props === void 0 ? void 0 : props.shouldHighlightElement)) {
        return React.createElement(React.Fragment, null, props === null || props === void 0 ? void 0 : props.children);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "overlay" }), props === null || props === void 0 ? void 0 :
        props.children));
};
export default ComponentHighlightWrapper;
//# sourceMappingURL=ComponentHighlightWrapper.js.map